import React, { useState, useEffect } from "react";
import {
  Button,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Table,
} from "reactstrap";
import "../../assets/css/Profile.css";
import Heart from "../../assets/Profile/Heart.svg";
import "../../assets/css/tableRoundHeader.css";
import ClientHeader from "../../components/ClientHeader";
import {
  getDeadlinesDays,
  getEditorTasks,
  getPendingTasks,
  updateDeadlines,
  updateTaskData,
} from "../../API/TaskApi";
import dayjs from "dayjs";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Cookies from "js-cookie";
import { Form } from "react-router-dom";
import Select from "react-select";
import { useLoggedInUser } from "../../config/zStore";

function DeadlineDays(props) {
  const [deadlinesData, setDeadlinesData] = useState(null);
  const [tempDeadlines, setTempDeadlines] = useState(null);
  const [updating, setUpdating] = useState(false);
  const { userData: currentUser } = useLoggedInUser();
  const [modal, setModal] = useState(false);

  const toggle = () => {
    setTempDeadlines(deadlinesData);
    setModal(!modal);
  };
  const getDeadlineDaysData = async () => {
    try {
      if (currentUser?.rollSelect === "Admin") {
        const deadline = await getDeadlinesDays();
        setDeadlinesData(deadline);
        setTempDeadlines(deadline);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const updateTempDeadlines = (e) => {
    setTempDeadlines({ ...tempDeadlines, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    getDeadlineDaysData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // The deadline settings, each a whole number of days.
  const DEADLINE_FIELDS = ["photo", "album", "reel", "promo", "longFilm", "performanceFilms", "preWedPhoto", "preWedVideo"];

  const updateData = async () => {
    const invalid = DEADLINE_FIELDS.filter((field) => {
      const value = tempDeadlines?.[field];
      return value === "" || value === undefined || !/^\d+$/.test(String(value).trim());
    });
    if (invalid.length) {
      window.notify("Each deadline must be a whole number of days.", "error");
      return;
    }

    setUpdating(true);
    try {
      await updateDeadlines(tempDeadlines);
      window.notify("Updated successfully!", "success");
      // Only now show the new values and close the editor. Both used to happen
      // even when the save failed, displaying values that were never stored
      // (QA finding ADMIN-07).
      setDeadlinesData(tempDeadlines);
      setModal(false);
      getDeadlineDaysData();
    } catch (error) {
      // Keep the editor open with the draft, so it can be corrected and retried.
      window.notify(
        error?.response?.data?.message ||
          "Could not save the deadlines. Your changes are still here - try again.",
        "error"
      );
    } finally {
      setUpdating(false);
    }
  };

  return (
    <>
      <ToastContainer />
      <div className="d-flex justify-content-end w-100">
        <div
          style={{ backgroundColor: "#666DFF" }}
          className="btn btn-primary me-1"
          onClick={toggle}
        >
          Edit Deadlines
        </div>
      </div>
      {deadlinesData ? (
        <>
          <Table
            hover
            // bordered
            responsive
            className="tableViewClient"
            style={{ width: "100%", marginTop: "15px" }}
          >
            <>
              <thead>
                {currentUser?.rollSelect === "Admin" && (
                  <tr className="logsHeader Text16N1">
                    <th className="tableBody primary2">Deliverable</th>
                    <th className="tableBody primary2">Deadline Days</th>
                  </tr>
                )}
              </thead>
            </>

            <tbody
              className="Text12"
              style={{
                textAlign: "center",
                borderWidth: "1px 1px 1px 1px",
              }}
            >
              <>
                <tr aria-hidden="true" style={{ height: "15px" }} />
                {currentUser?.rollSelect === "Admin" && (
                  <>
                    <tr>
                      <td className="tableBody Text14Semi  tablePlaceContent">
                        Long Films
                      </td>

                      <td className="tableBody Text14Semi tablePlaceContent">
                        {deadlinesData.longFilm}
                      </td>
                    </tr>
                    <tr>
                      <td className="tableBody Text14Semi  tablePlaceContent">
                        Reels
                      </td>

                      <td className="tableBody Text14Semi  tablePlaceContent">
                        {deadlinesData.reel}
                      </td>
                    </tr>
                    <tr>
                      <td className="tableBody Text14Semi  tablePlaceContent">
                        Promos
                      </td>

                      <td className="tableBody Text14Semi  tablePlaceContent">
                        {deadlinesData.promo}
                      </td>
                    </tr>
                    <tr>
                      <td className="tableBody Text14Semi  tablePlaceContent">
                        Performance Films
                      </td>

                      <td className="tableBody Text14Semi  tablePlaceContent">
                        {deadlinesData.performanceFilms}
                      </td>
                    </tr>
                    <tr>
                      <td className="tableBody Text14Semi  tablePlaceContent">
                        Photos
                      </td>

                      <td className="tableBody Text14Semi  tablePlaceContent">
                        {deadlinesData.photo}
                      </td>
                    </tr>
                    <tr>
                      <td className="tableBody Text14Semi  tablePlaceContent">
                        Albums
                      </td>

                      <td className="tableBody Text14Semi  tablePlaceContent">
                        {deadlinesData.album}
                      </td>
                    </tr>
                    <tr>
                      <td className="tableBody Text14Semi  tablePlaceContent">
                        Pre-Wedding Photos
                      </td>

                      <td className="tableBody Text14Semi  tablePlaceContent">
                        {deadlinesData.preWedPhoto}
                      </td>
                    </tr>
                    <tr>
                      <td className="tableBody Text14Semi  tablePlaceContent">
                        Pre-Wedding Videos
                      </td>

                      <td className="tableBody Text14Semi  tablePlaceContent">
                        {deadlinesData.preWedVideo}
                      </td>
                    </tr>
                  </>
                )}
              </>
            </tbody>
          </Table>

          <Modal
            isOpen={modal}
            toggle={toggle}
            centered={true}
            fullscreen="sm"
            size="lg"
          >
            <ModalHeader>Edit Deliverables Deadline Days</ModalHeader>

            <ModalBody>
              <Row className="p-3">
                <Col xl="2" sm="2" lg="2" className="p-2">
                  <div className="label">Long Films</div>
                </Col>
                <Col xl="4" sm="4" lg="4" className="p-2">
                  <div className="label">
                    <input
                      type="number"
                      name="longFilm"
                      onChange={updateTempDeadlines}
                      value={tempDeadlines?.longFilm}
                      className="w-100"
                      required
                    />
                  </div>
                </Col>
              </Row>
              <Row className="p-3">
                <Col xl="2" sm="2" lg="2" className="p-2">
                  <div className="label">Reels</div>
                </Col>
                <Col xl="4" sm="4" lg="4" className="p-2">
                  <div className="label">
                    <input
                      type="number"
                      name="reel"
                      onChange={updateTempDeadlines}
                      value={tempDeadlines?.reel}
                      className="w-100"
                      required
                    />
                  </div>
                </Col>
              </Row>
              <Row className="p-3">
                <Col xl="2" sm="2" lg="2" className="p-2">
                  <div className="label">Promos</div>
                </Col>
                <Col xl="4" sm="4" lg="4" className="p-2">
                  <div className="label">
                    <input
                      type="number"
                      name="promo"
                      onChange={updateTempDeadlines}
                      value={tempDeadlines?.promo}
                      className="w-100"
                      required
                    />
                  </div>
                </Col>
              </Row>
              <Row className="p-3">
                <Col xl="2" sm="2" lg="2" className="p-2">
                  <div className="label">Performance Films</div>
                </Col>
                <Col xl="4" sm="4" lg="4" className="p-2">
                  <div className="label">
                    <input
                      type="number"
                      name="performanceFilms"
                      onChange={updateTempDeadlines}
                      value={tempDeadlines?.performanceFilms}
                      className="w-100"
                      required
                    />
                  </div>
                </Col>
              </Row>
              <Row className="p-3">
                <Col xl="2" sm="2" lg="2" className="p-2">
                  <div className="label">Photos</div>
                </Col>
                <Col xl="4" sm="4" lg="4" className="p-2">
                  <div className="label">
                    <input
                      type="number"
                      name="photo"
                      onChange={updateTempDeadlines}
                      value={tempDeadlines?.photo}
                      className="w-100"
                      required
                    />
                  </div>
                </Col>
              </Row>
              <Row className="p-3">
                <Col xl="2" sm="2" lg="2" className="p-2">
                  <div className="label">Albums</div>
                </Col>
                <Col xl="4" sm="4" lg="4" className="p-2">
                  <div className="label">
                    <input
                      type="number"
                      name="album"
                      onChange={updateTempDeadlines}
                      value={tempDeadlines?.album}
                      className="w-100"
                      required
                    />
                  </div>
                </Col>
              </Row>
              <Row className="p-3">
                <Col xl="2" sm="2" lg="2" className="p-2">
                  <div className="label">Pre-Wedding Photos</div>
                </Col>
                <Col xl="4" sm="4" lg="4" className="p-2">
                  <div className="label">
                    <input
                      type="number"
                      name="preWedPhoto"
                      onChange={updateTempDeadlines}
                      value={tempDeadlines?.preWedPhoto}
                      className="w-100"
                      required
                    />
                  </div>
                </Col>
              </Row>
              <Row className="p-3">
                <Col xl="2" sm="2" lg="2" className="p-2">
                  <div className="label">Pre-Wedding Videos</div>
                </Col>
                <Col xl="4" sm="4" lg="4" className="p-2">
                  <div className="label">
                    <input
                      type="number"
                      name="preWedVideo"
                      onChange={updateTempDeadlines}
                      value={tempDeadlines?.preWedVideo}
                      className="w-100"
                      required
                    />
                  </div>
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button onClick={updateData} className="Update_btn">
                {updating ? "Updating.." : "ADD"}
              </Button>
              <Button type="button" color="danger" onClick={toggle}>
                Cancel
              </Button>
            </ModalFooter>
          </Modal>
        </>
      ) : (
        <div
          style={{ height: "400px" }}
          className="d-flex justify-content-center align-items-center"
        >
          <div className="spinner"></div>
        </div>
      )}
    </>
  );
}

export default DeadlineDays;
